import { es, ptBR, enUS } from 'date-fns/locale';

export const LOCALES = { es, pt: ptBR, en: enUS };
const pad = (n) => String(n).padStart(2, '0');

// Day-month-year for any ISO date/datetime; date-only strings are read without timezone shift
export const fmtDate = (v, withTime = false) => {
  if (!v) return '';
  const s = String(v);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s.split('-').reverse().join('-');
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  const base = `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
  return withTime ? `${base} ${pad(d.getHours())}:${pad(d.getMinutes())}` : base;
};

export const toIsoDay = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const fromIsoDay = (s) => (s ? new Date(`${s.slice(0, 10)}T12:00:00`) : undefined);
